import React, {
	Component
} from 'react';
import { Input, Select, Form, Button, Table ,Row,Col,Breadcrumb,message,DatePicker} from 'antd';
import {actionRecordMapType,questionColumns,relationColumns,recordColumns,questionRelationColumns,relationTypeCheck} from './constData'
import Question from '@/entry_question_editor/question/question_view/view';
import {getQuestionRecordAPI,getRelationRecordAPI} from '@/API'
import './index.css'

const Option = Select.Option;
const {RangePicker} = DatePicker;

const questionActionOptions=actionRecordMapType.question.map(v=><Option value={v.value} key={v.value}>{v.label}</Option>)
const relationStatusOptions=actionRecordMapType.relation.map(v=><Option value={v.value} key={v.value}>{v.label}</Option>)


export  class QuestionRecord extends Component {


	static contextTypes={
	    router: React.PropTypes.object.isRequired,
	    dispatch: React.PropTypes.func.isRequired
	}
	constructor(props) {
	    super(props);
	    this.state={
			questionId:'',
			loading:false,
			questionActionType:'0',
			questionRecordList:[],
			relationRecordList:[],			
			latestTime:undefined,
			relationStatus:'-1'
		}

    }
	componentDidMount() {
		
	}
	handleSerach=()=>{
		if(!this.state.questionId)return
		this.getQuestionRecord(1)
		this.getRelationRecord(1)
	}
	handleQuestionChange=(e)=>{
		this.setState({questionId:e.target.value})
	}
	handleChange(val,setKey,changeType){
		let self=this
		this.setState({[setKey]:val},function(){
			changeType=='question'?self.getQuestionRecord():self.getRelationRecord()
		})
		
	}
	getQuestionRecord(){
		this.setState({loading:true})
		let {questionId,questionActionType}=this.state
		let params={
			question_id:questionId,
			type:questionActionType
		}
		getQuestionRecordAPI(params).then(res=>{
			this.setState({
				questionRecordList:res.data,
				loading:false
			})
		})
	}
	getRelationRecord(){
		this.setState({loading:true})
		let {questionId,latestTime,relationStatus}=this.state
		let params={
			question_id:questionId,
			type:relationStatus,
			start_time:latestTime?latestTime[0]:undefined,
			end_time:latestTime?latestTime[1]:undefined
		}
		getRelationRecordAPI(params).then(res=>{
			this.setState({
				relationRecordList:res.data,
				loading:false
			})
		})
	}


	
	render() {
		const {
			questionId,latestTime,questionActionType,loading,
			questionRecordList,
			relationRecordList,relationStatus
			
		}=this.state

		return(
			<div className="question-record">
				<Breadcrumb>
                    <Breadcrumb.Item style={{fontSize:20}}><span>题目管理</span></Breadcrumb.Item>
                    <Breadcrumb.Item style={{fontSize:20}}><span>题目日志</span></Breadcrumb.Item>
                </Breadcrumb>
        			 <Form style={{margin:'15px 0'}}>
        			 	<Row gutter={16}>
        			 		<Col span={3}>
        			 			<Form.Item
						      label=""
						      validateStatus={questionId?"":"error"}
						      help={questionId?"":"请输入题目id搜索"}
						    >
						    <Input value={questionId} onChange={this.handleQuestionChange} placeholder="输入题目ID" />
						    </Form.Item>
        			 		</Col>
        			 		<Col span={9}>
        			 			 <Button type="primary" size="large" onClick={this.handleSerach}>搜索</Button>
        			 		</Col>
        			 		<Col span={6}></Col>
        			 		<Col span={6}></Col>
        			 	</Row>
				 </Form>
        			<div>
        				<div style={{margin:'15px 0'}}><h2>题目操作记录</h2></div>
        				<div style={{margin:'15px 0'}}>
        					<span>操作类型:</span>
        					<Select defaultValue="0" value={questionActionType} style={{ width: 120,marginLeft:'15px' }} onChange={(val)=>this.handleChange(val,'questionActionType','question')}>
        					{questionActionOptions}
        					</Select>
        				</div>
        				<Table
					    columns={questionColumns}
					    expandedRowRender={record =>{
						    		if(relationTypeCheck.includes(record.type)){
						    			return <Table  columns={questionRelationColumns} dataSource={[record.params]} rowKey={(record)=>record.section_id} />
						    		}else if(['120','121','122','130'].includes(record.type)){
						    			return false
						    		}else{
						    			return <Question data={record.params}  showRelative={false}  />
						    		}
						    }
					    	}
					    dataSource={questionRecordList}
					    rowKey={(record)=>record.log_id}
					    loading={loading}

					  />
        			</div>
        			<div>
        				<div style={{margin:'15px 0'}}><h2>题目——章节关联关系操作记录</h2></div>
        				<div style={{margin:'15px 0'}}>
        					<span style={{ diaplay:'inline-block',marginRight:'15px' }}>最后操作时间:</span>
        					<RangePicker style={{marginRight:'15px' }} onChange={(date)=>this.handleChange(date,'latestTime','relation')} value={latestTime} />
        					<span >状态:</span>
        					<Select defaultValue="0" value={relationStatus} style={{ width: 120,marginLeft:'15px' }} onChange={(val)=>this.handleChange(val,'relationStatus','relation')}>
        					{relationStatusOptions}
        					</Select>
        				</div>
        				<Table
					    columns={relationColumns}
					    expandedRowRender={record => 
					    		<Table  columns={recordColumns} dataSource={record.log_list} rowKey={(record)=>record.log_id} />
					    }
					    dataSource={relationRecordList}
					    loading={loading}
					    rowKey={(record)=>record.relate_id}
						
					  />
        			</div>
        		</div>
		);

	}
}


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/look_over_question/question_record/index.js